"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var styles=require("@material-ui/core/styles");let t=styles.makeStyles(e=>({thumbArrow:{"&:first-child":{transform:"rotate(180deg)"},color:e.palette.common.blue400,fill:"currentColor"}}));exports.default=t;
//# sourceMappingURL=styles.js.map
